import React from "react";
import "./Contact.css";
import {
  FaPhone,
  FaEnvelope,
  FaGlobe,
  FaWhatsapp,
  FaMapMarkerAlt,
} from "react-icons/fa";
import backgroundImage from "../../assets/contact.webp";
import SEOHead from "../../seo/SEOHead";
import { seoConfig } from "../../seo/seoConfig";
import { localBusinessSchema1, generateBreadcrumbs } from "../../seo/structuredData";

const Contact: React.FC = () => {
  const openWhatsApp = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const phoneNumber = "4915903782712";
    const url = isMobile
      ? `whatsapp://send?phone=${phoneNumber}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}`;
    window.open(url, "_blank");
  };

  return (
    <div className="contact-container">
      <SEOHead
        {...seoConfig.kontakt}
        structuredData={[
          localBusinessSchema1,
          generateBreadcrumbs([
            { name: 'Home', url: 'https://www.styror.com/' },
            { name: 'Kontakt', url: 'https://www.styror.com/kontakt' },
          ]),
        ]}
      />
      <div
        className="contact-background"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="background-overlay"></div>
      </div>
      <div className="contact-content">
        <div className="contact-info">
          <h1 className="contact-title">Kontakt & Standort – StyroR</h1>
          <div className="company-info">
            <h2>StyroR – Ihr Spezialist für EPS Recycling</h2>
            <p>
              Styropor Recycling Management und Beratung UG
            </p>
            <p>
              Jetzt Anfrage stellen für professionelle Styropor Entsorgung, Isolierung Recycling und umweltgerechte EPS-Verwertung in Hamburg.
            </p>
          </div>
          <div className="contact-details">
            <div className="contact-item">
              <FaMapMarkerAlt className="icon" />
              <div>
                <p>Rennbahnstraße 2, 22111 Hamburg</p>
              </div>
            </div>
            <div className="contact-item">
              <FaPhone className="icon" />
              <a href="tel:+4915903782712">+49 (0)1590 - 37 82 712</a>
            </div>
            <div className="contact-item">
              <FaEnvelope className="icon" />
              <a href="mailto:info@styror.com">info@styror.com</a>
            </div>
            <div className="contact-item">
              <FaGlobe className="icon" />
              <a
                href="https://www.styror.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.styror.com
              </a>
            </div>
          </div>
          <button onClick={openWhatsApp} className="whatsapp-button">
            <FaWhatsapp /> WhatsApp Chat starten
          </button>

          <div className="contact-about">
            <h2>Unser Standort in Hamburg</h2>
            <p>
              StyroR betreibt einen Standort in Hamburg, der optimal auf die Annahme und Verarbeitung
              von Styropor und EPS ausgerichtet ist. An unserem Standort in der Rennbahnstraße 2 in
              Hamburg-Horn nehmen wir Ihr Styropor entgegen – ob sauber, verschmutzt oder HBCD-belastet.
              Unser Standort verfügt über ausreichend Kapazität für die Annahme großer Mengen und ist
              mit moderner Technik zur Volumenreduzierung ausgestattet. Eine Anlieferung ist nach
              vorheriger Absprache möglich. Für regelmäßige Entsorgungen bieten wir individuelle
              Rahmenvereinbarungen an, die Ihnen Planungssicherheit und günstige Konditionen garantieren.
            </p>

            <h2>Ablauf Ihrer Anfrage</h2>
            <p>
              Stellen Sie Ihre Anfrage bequem per Telefon, E-Mail oder WhatsApp. Teilen Sie uns Art
              und Menge des zu entsorgenden Styropors mit, und wir erstellen Ihnen zeitnah ein
              individuelles Angebot. Bei größeren Mengen organisieren wir die Abholung direkt bei
              Ihnen vor Ort. Auch die Bereitstellung von Containern für Baustellen und Gewerbebetriebe
              gehört zu unserem Leistungsumfang. Nach Eingang Ihrer Anfrage melden wir uns in der
              Regel innerhalb von 24 Stunden mit einem konkreten Angebot bei Ihnen zurück.
              Selbstverständlich beraten wir Sie auch vorab kostenlos und unverbindlich zu den
              verschiedenen Entsorgungsmöglichkeiten und helfen Ihnen, die wirtschaftlichste
              Lösung für Ihre Situation zu finden.
            </p>

            <h2>Für wen ist StyroR der richtige Partner?</h2>
            <p>
              Unser Service richtet sich an Abbruchunternehmen, Bauunternehmen, Dachdeckerbetriebe,
              Entsorgungsunternehmen, Facility-Management-Firmen und Handwerksbetriebe in Hamburg
              und Umgebung. Auch Privatpersonen mit größeren Mengen an Dämmstyropor sind bei
              uns willkommen. Ob einzelne Säcke oder ganze Containerladungen – wir finden für jede
              Menge die passende Lösung. Kontaktieren Sie uns noch heute und profitieren Sie von
              unserer langjährigen Erfahrung in der Styropor-Entsorgung und EPS-Verwertung.
            </p>

            <h2>Welche Materialien nehmen wir an?</h2>
            <p>
              Wir entsorgen und recyceln sämtliche Arten von expandiertem Polystyrol (EPS) und
              extrudiertem Polystyrol (XPS). Dazu gehören Styropor-Dämmplatten aus Fassaden- und
              Dachdämmung, Verpackungsstyropor aus Industrie und Handel sowie HBCD-belastetes
              Styropor, das als gefährlicher Abfall gilt und besondere Entsorgungswege erfordert.
              Auch verschmutztes oder mit Putz und Kleber behaftetes Dämmmaterial nehmen wir an.
              Sie sind unsicher, ob Ihr Material für unser Recycling geeignet ist? Schicken Sie
              uns einfach ein Foto per WhatsApp oder E-Mail – wir beraten Sie gerne und
              unkompliziert.
            </p>

            <h2>Ihre Vorteile mit StyroR</h2>
            <p>
              Mit StyroR sparen Sie Entsorgungskosten, denn durch unsere effiziente
              Volumenreduzierung und direkte Verwertungswege bieten wir Ihnen attraktive Konditionen.
              Gleichzeitig leisten Sie einen aktiven Beitrag zum Umweltschutz: Recyceltes Polystyrol
              wird in den Produktionskreislauf zurückgeführt und spart wertvolle Rohstoffe sowie
              CO2-Emissionen. Unser erfahrenes Team steht Ihnen von der ersten Anfrage bis zur
              abgeschlossenen Entsorgung persönlich zur Seite. Auf Wunsch erhalten Sie ein
              Umweltschutz-Zertifikat, das Ihr Engagement für nachhaltiges Wirtschaften dokumentiert
              und Ihr Unternehmensimage bei Kunden und Geschäftspartnern stärkt. Wir freuen uns
              auf Ihre Nachricht und beraten Sie gerne zu allen Fragen rund um die Entsorgung
              und das Recycling von Styropor, EPS und verwandten Materialien.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
